<template>
  <v-container fluid>
    <v-container class="pa-0" fluid>
      <v-row no-gutters fluid>
        <v-col cols="9" class="pa-0 pr-4">
          <v-row class="pa-0">
            <v-col class="pa-0">
              <v-card height="180">
                <v-card-title class="pb-0">Descrição do sorteio no app</v-card-title>
                <v-card-text>{{ fortmattedAppDescription }}</v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="pa-0 pl-2">
              <v-card height="180">
                <v-card-title class="pb-0">Regras do sorteio</v-card-title>
                <v-card-text>
                  <router-link class="d-flex flex-row align-center" :to="{ path: raffle.rules_url }">
                    <mf-icon color="marca-0-l40">description</mf-icon>
                    <v-card-text class="text-decoration-underline">{{ rulesFileName }}</v-card-text>
                  </router-link>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-0 pr-3 pl-3" fluid>
              <participating-products
                v-if="canConfigureProducts"
                :products.sync="raffle.rules.products"
                :status-campaign="raffle.status"
                isConfirmPage
                :eans="eans"
                :editable="false"
                is-disabled
                :acceleration-operation.sync="raffle.rules.acceleration_operation"
                :acceleration-value.sync="raffle.rules.acceleration_value"
              />
              <participating-product-groups v-if="canConfigureProductGroups" is-confirm :product-groups="raffle.rules.product_groups" is-disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col fluid>
              <prizes-table :raffle="raffle" :prizeSearch="prizeSearch" :isDisabled="true" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="pl-2">
          <v-card class="raffle-info pb-2">
            <v-card-title class="pb-0 title raffle-title">{{ raffle.title }}</v-card-title>
            <v-card-text>{{ raffle.description }}</v-card-text>
            <v-card-subtitle class="mf-subtitle-2 pt-2"><b>Período do sorteio:</b></v-card-subtitle>
            <v-card-text>{{ `${formattedRaffleDates.startDate} - ${formattedRaffleDates.endDate}` }}</v-card-text>
            <div v-if="raffle.available_in_app">
              <v-card-subtitle class="mf-subtitle-2 pt-2"><b>Data de início de exibição do sorteio no app:</b></v-card-subtitle>
              <v-card-text>{{ formattedRaffleDates.appExhibitionDate }}</v-card-text>
            </div>
            <v-card-subtitle class="mf-subtitle-2 pt-2"><b>Segmentos de inclusão no sorteio:</b></v-card-subtitle>
            <v-card-text>
              <v-chip-group v-if="raffle.segments.length" show-arrows active-class="primary--text" column>
                <v-chip v-for="(segmento, index) in raffle.segments" :key="`${index}-inclusion-segment`" small :ripple="false">
                  <span>
                    <strong class="pr-2">{{ segmento.name }}</strong>
                    <span>({{ segmento.clients_qty | hifen | localeString }} clientes)</span>
                  </span>
                </v-chip>
              </v-chip-group>
              <span v-else>Sem segmentos</span>
            </v-card-text>
            <v-card-subtitle class="mf-subtitle-2 pt-2"><b>Segmentos de exclusão no sorteio:</b></v-card-subtitle>
            <v-card-text>
              <v-chip-group v-if="raffle.exclusion_segments.length" show-arrows active-class="primary--text" column>
                <v-chip v-for="(segmento, index) in raffle.exclusion_segments" :key="`${index}-exclusion-segment`" small :ripple="false">
                  <span>
                    <strong class="pr-2">{{ segmento.name }}</strong>
                    <span>({{ segmento.clients_qty | hifen | localeString }} clientes)</span>
                  </span>
                </v-chip>
              </v-chip-group>
              <span v-else>Sem segmentos</span>
            </v-card-text>
            <v-card-subtitle class="mf-subtitle-2 pt-2"><b>Tipo de sorteio:</b></v-card-subtitle>
            <p class="hint-text pr-4 pl-4">
              <b>{{ raffleTypeText.type }}</b> - {{ raffleTypeText.description }}
            </p>
            <v-card-subtitle class="mf-subtitle-2 pt-2"><b>Modelo de geração de números da sorte:</b></v-card-subtitle>
            <p class="hint-text pr-4 pl-4">
              <b>{{ raffleLuckyNumberType }}</b>
            </p>
            <v-card-subtitle v-if="showRegisterNumber" class="mf-subtitle-2 pt-2"><b>Registro:</b></v-card-subtitle>
            <p v-if="raffle.register_number" class="hint-text pr-4 pl-4">
              <b>{{ raffle.register_number }}</b>
            </p>
            <v-card-subtitle class="mf-subtitle-2 pt-2"
              ><b>{{ raffleValue.title }}</b></v-card-subtitle
            >
            <p class="hint-text pr-4 pl-4">
              <b>{{ raffleValue.value }}</b>
            </p>
            <v-card-subtitle class="mf-subtitle-2 pt-2"><b>Valores Acumulativos:</b></v-card-subtitle>
            <p class="hint-text pr-4 pl-4">
              <b>{{ raffle.rules.cumulative ? 'Sim' : 'Não' }}</b>
            </p>
            <v-card-subtitle v-if="$getAllowedModules()['terms_optin']" class="mf-subtitle-2 pt-2"><b>Termos:</b></v-card-subtitle>
            <p v-if="$getAllowedModules()['terms_optin']" class="hint-text pr-4 pl-4">
              <b>{{ raffle.optin.active ? 'Sim' : 'Não' }}</b>
            </p>
            <v-card-subtitle v-if="raffle.max_numbers_per_person" class="mf-subtitle-2 pt-2"><b>Limite de números da sorte por pessoa:</b></v-card-subtitle>
            <p v-if="raffle.max_numbers_per_person" class="hint-text pr-4 pl-4">
              <b>{{ raffle.max_numbers_per_person }}</b>
            </p>
            <v-card-subtitle v-if="raffle.max_numbers_per_coupon" class="mf-subtitle-2 pt-2"><b>Limite de números da sorte por cupom:</b></v-card-subtitle>
            <p v-if="raffle.max_numbers_per_coupon" class="hint-text pr-4 pl-4">
              <b>{{ raffle.max_numbers_per_coupon }}</b>
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <mf-action-buttons
      class="mt-2"
      :primary-button="{
        text: 'Confirmar',
        action: () => submit(),
        isVisible: true,
        isLoading: isSubmitting,
      }"
      :secondary-button="{
        text: 'Voltar',
        action: () => $emit('goBack'),
        isVisible: true,
        isLoading: isSubmitting,
      }"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PrizesTable from './PrizesTable.vue'
import { localeString } from '@/config/helpers.js'
import ParticipatingProducts from './ParticipatingProducts.vue'
import ParticipatingProductGroups from './ParticipatingProductGroups.vue'
import { raffleMixin } from '@/modules/mobile/sorteio/views/mixins/raffle'

export default {
  name: 'ConfirmRaffle',
  components: {
    PrizesTable,
    ParticipatingProducts,
    ParticipatingProductGroups,
  },
  mixins: [raffleMixin],
  props: {
    eans: {
      type: Array,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    raffleEndDate: String,
  },
  data: () => ({
    prizeSearch: '',
    showConfirmDialog: false,
  }),
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    ...mapGetters(['formattedRaffleDates']),
    raffleLuckyNumberType() {
      return this.raffle.lucky_number_generation_type === 'SECAP' ? 'Padrão Loteria Federal' : 'Sequencial'
    },
    showRegisterNumber() {
      return this.raffle.register_number && this.raffle.lucky_number_generation_type === 'SECAP'
    },
    fortmattedAppDescription() {
      if (!this.raffle.app_description) return ''
      return this.raffle.app_description?.length > 200 ? `${this.raffle.app_description.substring(0, 400)} ...` : this.raffle.app_description
    },
    raffleTypeText() {
      let type, description
      switch (this.raffle.rules.type) {
        case 'BY_COUPON_TOTAL_VALUE':
          type = 'Por valor'
          description = 'O cliente deve levar o valor mínimo estipulado de produtos, não específicos, para receber um cupom.'
          break
        case 'BY_SELECTED_ITEMS_QUANTITY':
          type = 'Por quantidade de produtos'
          description = 'O cliente deve levar uma quantidade mínima estipulada de produtos, específicos, para receber um cupom.'
          break
        case 'BY_SELECTED_ITEMS_VALUE':
          type = 'Por valor de produtos'
          description = 'O cliente deve levar o valor mínimo estipulado de produtos, específicos, para receber um cupom.'
          break
        case 'BY_COUPON_TOTAL_VALUE_PARTICIPANT_PRODUCT':
          type = 'Por valor e produto'
          description = 'O cliente deve levar o valor mínimo estipulado e algum dos produtos específicos para receber um número da sorte.'
          break
        case 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT':
          type = 'Por valor com produto acelerador'
          description =
            'O cliente deve levar o valor mínimo estipulado para receber um número da sorte. Caso o consumidor leve produtos aceleradores ele ganhará cupons extras.'
          break
        case 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT_GROUPS_WITH_CUMULATIVE':
          type = 'Por valor com grupo de produto acelerador'
          description =
            'O cliente deve levar o valor mínimo estipulado para receber um número da sorte. Caso o consumidor leve produtos dos grupos aceleradores ele ganhará cupons extras.'
          break
        default:
          break
      }
      return {
        type,
        description,
      }
    },
    raffleValue() {
      let title, value
      switch (this.raffle.rules.type) {
        case 'BY_COUPON_TOTAL_VALUE':
        case 'BY_SELECTED_ITEMS_VALUE':
        case 'BY_COUPON_TOTAL_VALUE_PARTICIPANT_PRODUCT':
        case 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT':
        case 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT_GROUPS_WITH_CUMULATIVE':
          title = 'Valor mínimo:'
          value = `R$ ${localeString(this.raffle.rules.value, 2)}`
          break
        case 'BY_SELECTED_ITEMS_QUANTITY':
          title = 'Quantidade mínima de produtos:'
          value = this.raffle.rules.value
          break
        default:
          break
      }
      return {
        title,
        value,
      }
    },
    rulesFileName() {
      let splitName = this.raffle.rules_url.split('/').pop().split('-')
      if (this.raffle.rules_url.split('/').length === 1) return this.raffle.rules_url
      return splitName.slice(5, splitName.length).join('-')
    },
  },
  methods: {
    submit() {
      this.$emit('submit')
      this.showConfirmDialog = false
    },
    setShowConfirmDialog(value) {
      if (this.raffle.status !== 'DRAFT') {
        return this.$emit('submit')
      }
      this.showConfirmDialog = value
    },
    confirmRaffleDialog() {
      const isAdmin = this.$getIsAdmin()
      const title = isAdmin ? 'Salvar sorteio como admin' : 'Enviar para aprovação'
      const imgStyle = 'display: block;margin: 8px auto 20px;'
      const img = `<img src="${require('@/assets/on-approval-raffle.png')}" style="${imgStyle}" />`
      const message = isAdmin
        ? `${img} Ao aprovar a versão do sorteio como admin, as alterações já serão disponibilizadas no aplicativo e utilizadas na geração de novos números da sorte.`
        : `${img} Agora as campanhas de sorteio contam com uma nova etapa: a aprovação do consultor responsável. Ao confirmar o envio para a aprovação, o consultor receberá um comunicado e deverá aprovar a campanha, antes que ela entre como "Ativa". Confirme que todos os dados cadastrados estão corretos antes de enviar.`

      this.$confirm({
        title,
        message,
        confirmText: isAdmin ? 'Confirmar' : 'Enviar para aprovação',
        cancelText: 'Cancelar',
      })
        .then(() => {
          this.submit()
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.mf-subtitle-2 {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.2px;
  padding-bottom: 5px;
}
.hint-text {
  font-size: 14px;
  line-height: 21px;
  &.external {
    max-width: 700px;
  }
  b {
    color: $marca-1;
    font-weight: 700;
  }
}
.raffle-info {
  min-height: 600px;
}
.raffle-title {
  word-break: normal;
}
</style>
